// Strip past dates from AI-parsed data before populating the form.
// Moves the detected past date/time to notes so the user sees what was detected.
export function stripPastDate(data, lang = 'it', t = null) {
  if (!data?.dueDate) return data
  const today = new Date(); today.setHours(0, 0, 0, 0)
  const due = new Date(data.dueDate + 'T00:00:00')
  if (due >= today) return data

  const formatted = new Intl.DateTimeFormat(lang === 'it' ? 'it-IT' : 'en-GB',
    { day: 'numeric', month: 'long', year: 'numeric' }).format(due)
  const timeStr = data.dueTime ? ` ${data.dueTime}` : ''
  const noteLabel = t
    ? t('past_date_note', { date: formatted, time: timeStr })
    : `⚠️ ${formatted}${timeStr}`
  const existingNotes = data.notes ? data.notes.trim() : ''
  return {
    ...data,
    dueDate: null,
    dueTime: null,
    reminder: false,
    reminderMinutes: 15,
    notes: existingNotes ? `${noteLabel}\n\n${existingNotes}` : noteLabel,
  }
}
